module.exports = __webpack_public_path__ + "static/img/vscode.def13e51.svg";